import { EMPTY_LIST } from '../../../../../constants/common'

export function filterNoEmailAccounts(value, listToRemove) {
  if (value.length === 0) {
    return EMPTY_LIST
  }

  return value.filter(i => !listToRemove.includes(i.value))
}
